export const TOOLTIP_SHOW_DELAY = 350;
